<template>
  <div class="inspection-list">
    <template v-if="hasInspections">
      <InspectionListCard
        v-for="inspection in hgInspections"
        :key="`inspection_card_${inspection.id}`"
        :inspection="inspection" />
    </template>
    <Alert v-else lead-in="No Inspections found" type="info">
        We're sorry, but we couldn't find any Inspections for you.
        Please check with your inspector if you believe this is an error.
    </Alert>
  </div>
</template>

<script>
import Alert from '@/components/Shared/Alert.vue';
import InspectionListCard from './InspectionListCard.vue';

export default {
  components: {
    Alert,
    InspectionListCard,
  },
  props: {
    hgInspections: {
      type: Array,
      required: true,
    },
  },
  computed: {
    hasInspections() {
      return !!(this.hgInspections && this.hgInspections.length > 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.inspection-list {
  display: flex;
  flex-wrap: wrap;
  max-width: 1100px; /* fix for ie 11 */
}

@media all and (max-width: 1195px) {
  .inspection-list {
    display: run-in; /* fix for ie 11 */
    flex-direction: column;
  }
}
</style>
